import { useState } from 'react';

export function useAdminModal({
    setError,
    setSuccess,
    setUsers,
    adminService,
    setEditMode
}) {
  const [editedUser, setEditedUser] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const handleEditRoles = (userToEdit) => {
    setEditedUser(userToEdit);
    setEditMode('roles');
    setSelectedRoles(userToEdit.roles || []);
    setError('');
    setSuccess('');
  };

  const handleEditPermissions = (userToEdit) => {
    setEditedUser(userToEdit);
    setEditMode('permissions');
    // Get user's direct permissions (we need to track what user has directly vs from roles)
    // For now, we'll use all permissions and let admin toggle them
    setSelectedPermissions(userToEdit.permissions || []);
    setError('');
    setSuccess('');
  };

  const handleCloseModal = () => {
    setEditedUser(null);
    setEditMode(null);
    setSelectedRoles([]);
    setSelectedPermissions([]);
    setError('');
  };

  const handleRoleToggle = (roleName) => {
    setSelectedRoles(prev => 
      prev.includes(roleName)
        ? prev.filter(r => r !== roleName)
        : [...prev, roleName]
    );
  };

  const handlePermissionToggle = (permName) => {
    setSelectedPermissions(prev => 
      prev.includes(permName)
        ? prev.filter(p => p !== permName)
        : [...prev, permName]
    );
  };

  const handleSaveRoles = async () => {
    if (!editedUser) return;
    setError('');
    setSuccess('');
    
    try {
      await adminService.updateUserRoles(editedUser.id, selectedRoles);
      setSuccess(`Roles updated for ${editedUser.full_name}`);
      const updatedUsers = await adminService.getAllUsers();
      setUsers(updatedUsers);
      setTimeout(() => { setEditedUser(null); setSuccess(''); }, 1500);
    } catch (err) {
      setError('Failed to update roles. ' + (err.response?.data?.detail || ''));
    }
  };

  const handleSavePermissions = async () => {
    if (!editedUser) return;
    setError('');
    setSuccess('');
    
    try {
      await adminService.updateUserPermissions(editedUser.id, selectedPermissions);
      setSuccess(`Permissions updated for ${editedUser.full_name}`);
      const updatedUsers = await adminService.getAllUsers();
      setUsers(updatedUsers);
      setTimeout(() => { setEditedUser(null); setSuccess(''); }, 1500);
    } catch (err) {
      setError('Failed to update permissions. ' + (err.response?.data?.detail || ''));
    }
  };

  return {
    editedUser,
    setEditedUser,
    selectedRoles,
    selectedPermissions,
    handleEditRoles,
    handleEditPermissions,
    handleCloseModal,
    handleRoleToggle,
    handlePermissionToggle,
    handleSaveRoles,
    handleSavePermissions
  }
}
